import React from "react";
import Turnstile, { useTurnstile } from "react-turnstile";
import { cloudFlareverifiedRobotBoy } from "../../../api/postApi";
import { useSelector } from "react-redux";

const CustomTurnstile = ({ setIsVerify }) => {
  const turnstile = useTurnstile();
  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  return (
    <Turnstile
      sitekey={process.env.REACT_APP_CLOUDFLARE_KEY}
      theme={isDarkMode ? "dark" : "light"}
      fixedSize
      className="mt-[10px]"
      onVerify={(token) => {
        cloudFlareverifiedRobotBoy({ cloudFlareToken: token }).then((data) => {
          if (data.success) {
            setIsVerify(true);
          } else {
            setIsVerify(false);
            turnstile.reset();
          }
        });
      }}
    ></Turnstile>
  );
};

export default CustomTurnstile;
